const e = {
  postV1CancelExclusionid: {
    schema: {
      method: "post",
      url: "/v1/cancel/{exclusionId}",
      mediaType: "application/json"
    }
  },
  postV1OwnertypeOwneridCancelExclusionid: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/cancel/{exclusionId}",
      mediaType: "application/json"
    }
  },
  postV1Exclude: {
    schema: {
      method: "post",
      url: "/v1/exclude",
      mediaType: "application/json"
    }
  },
  postV1OwnertypeOwneridExclude: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/exclude",
      mediaType: "application/json"
    }
  },
  getV1ExclusionTemplates: {
    schema: {
      method: "get",
      url: "/v1/exclusion-templates"
    }
  },
  getV1PlayerExclusionTemplates: {
    schema: {
      method: "get",
      url: "/v1/player-exclusion-templates"
    }
  },
  postV1RevertCancellationExclusionid: {
    schema: {
      method: "post",
      url: "/v1/revert-cancellation/{exclusionId}"
    }
  },
  getV1Exclusions: {
    schema: {
      method: "get",
      url: "/v1/exclusions"
    }
  },
  getV1ExclusionsId: {
    schema: {
      method: "get",
      url: "/v1/exclusions/{id}"
    }
  }
};
export {
  e as v1Service
};
